module.exports = __webpack_public_path__ + "static/media/logo.aad6ac7a.svg";